// removed by extract-text-webpack-plugin
module.exports = {"totalSavings":"styles__totalSavings__2SeCL","buttons":"styles__buttons__gUWlg","tweetButton":"styles__tweetButton__3szCF","downloadButton":"styles__downloadButton__3Dn16","twitterIcon":"styles__twitterIcon__EGfA7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CompressImages/styles.scss
// module id = 849
// module chunks = 0